import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Props from './FooterComponent';
import Translation from "../../shared/Translation";

export class Footer extends Component<Props> {
    getCopyrightText = () => {
        let copyrightText = (this.props.partner?.copyright_year ?? new Date().getFullYear()) + ' ' + this.props.partner.copyright;
            if(this.props.partner.copyright_behalf) {
              copyrightText = <Translation interpolation={{copyright:copyrightText, partner:this.props.partner.copyright_behalf}}>{"checkout__copyright"}</Translation>
            }

        return copyrightText;
    }

    getMainEvent = () => {
        const events = this.props.eventState?.events;
        if (typeof events === 'object' && events !== null) {
            const eventsArray = Object.values(events);
            if (eventsArray.length) {
                const event = eventsArray[0]?.event;
                if (event) {
                    return event;
                }
            }
        }
        return null;
    }

    getLink = type => {
       const event = this.getMainEvent();
       return event ? event?.[type] : this.props.partner?.[type];
    }

    render() {
        if (!this.props.partner) {
            return null;
        }

        const tos_url     = this.getLink('tos_url');
        const privacy_url = this.getLink('privacy_url');
        const contact_url = this.getLink('contact_url');

        return(
            <footer className="page__footer">
                <div className="page__footer__top">
                    <div className="page__footer__left">
                        <ul className="footer__links">
                            {!!contact_url && <li className="footer__link-item"><a href={contact_url} target="_blank"><Translation>{"checkout__support"}</Translation></a></li>}
                            {!!tos_url && <li className="footer__link-item"><a href={tos_url} target="_blank"><Translation>{"checkout__terms_of_service"}</Translation></a></li>}
                            {!!privacy_url && <li className="footer__link-item"><a href={privacy_url} target="_blank"><Translation>{"checkout__privacy_policy"}</Translation></a></li>}
                        </ul>
                    </div>
                    <div className="page__footer__right">
                        <div className="footer__branding">
                            <a href={contact_url} className="footer__branding__image">
                                <span className="sr-only">{this.props.partner.name}</span>
                            </a>
                        </div>
                    </div>
                </div>
                <div className="page__footer__bottom">
                    <p className="copyright-text">&copy; {this.getCopyrightText()}</p>
                </div>
            </footer>
        )
    }
}

Footer.propTypes = {
    partner: PropTypes.object,
}

const mapStateToProps = (state, props) => {
    return {
        partner: state.partner,
        eventState: state.event,
    };
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
    }, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(Footer);
